import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const UserIcon: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 24, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 17 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.6596 19H2.37834C1.60646 19 0.834586 18.5844 0.418961 17.9312C-0.056039 17.2781 -0.115414 16.4469 0.181461 15.675C1.36896 12.6469 4.51584 10.6281 8.01896 10.6281C11.5221 10.6281 14.669 12.6469 15.8565 15.675C16.1533 16.3875 16.094 17.2781 15.619 17.9312C15.2033 18.5844 14.4315 19 13.6596 19ZM8.01896 9.5C5.40646 9.5 3.26896 7.3625 3.26896 4.75C3.26896 2.1375 5.40646 0 8.01896 0C10.6315 0 12.769 2.1375 12.769 4.75C12.769 7.3625 10.6315 9.5 8.01896 9.5Z"
        fill="currentColor"
      />
    </svg>
  )
})

UserIcon.displayName = 'UserIcon'
